import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home',
    component: () => import('../views/home/index.vue'),
    meta: { isKeepAlive: true }
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home/index.vue'),
    meta: { isKeepAlive: true }
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/home/list.vue'),
    meta: { isKeepAlive: true }
  }
]

const router = new VueRouter({
  routes
})
export default router
